import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import * as lookup from "../../../../static/lookup.json"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { JourneyContext } from "../../context/journeyContext"
import { ErrorContext } from "../../context/errorContext"
import { DataLayerEventContext } from "../../context/dataLayerEventContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
  whatsAppOptin,
  getTOFpaymentReceipt,
  saveTransactionDetails
} from "../../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel,
  DataLayerIntegration,
  transformReceiptToTransaction
} from "../../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, maskInFormat } from '../../../shared/functions'
const moment = require('moment')
export default function BiGsp(props) {
  let [isactive, setIsActive] = useState(true)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [dataLayerEventState, setDataLayerEventState] = useContext(DataLayerEventContext)

  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("now")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
  const [proceedWithOption, setProceedWithOption] = useState()
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(true);
  const [skipPayment, setSkipPayment] = useState(false)
    //container
    const RadioContainer = styled.div`
    width: 100%;
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      z-index: 999;
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      & > .radio-label {
        text-align: center;
      }
    }

    .card {
      width: 100%;
      border-radius: 1rem;
      padding: 1rem 0;
      border-radius: 15px;
      background-color: #fff;
      position: relative;
      margin: 0px;
      margin-bottom: 0px;
      cursor: pointer;
      height: 9rem;
      margin-top: 0px;
      box-shadow: 0px 0px 20px #ccc;
      transition: all 200ms;

      .amount {
        color: black;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ededed;
        color: black;
        text-align: center;
        padding-right: 34px;
      }
    }

    /*Check tick start  */
    .checked {
      background: #ededed;
      color: #ededed;
      position: absolute;
      left: 2rem;
      top: 1rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      padding: 8px;
      & > * {
        font-size: 1.2rem;
      }
    }

    input:checked ~ .card .checked {
      background: #fff;
      color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      color: var(--lumiq-card-bg);
    }
    /*Check tick end */

    .icon-container {
      font-size: 3rem;
      padding: 1rem;
      span {
        border-radius: 50%;
        padding: 1rem;

        background: #3e505d;
        .hero-icon {
          padding-top: 8px;
          color: #fff;
        }
      }
    }

    input:checked ~ .card {
      background-color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      background-color: var(--lumiq-card-bg);
      color: #fff;
      .icon-container-1 {
        span {
          background: #fff;
          .hero-icon {
            color: #3e505d;
          }
        }
      }

      .amount {
        color: white;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ffffff;
        color:black
        text-align: center;
        padding-right: 34px;
      }
    }

    input:not(:checked) ~ .card {
      /* opacity: 0.5; */
      .amount {
        color: #818181;
      }

      .desc {
        color: #3e505d;
      }
    }
    `
    //Helper Functions
    async function downloadLinkOfPdf(Base64Pdf) {
      // if(!location){
      //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
      //     Base64Pdf: Base64Pdf,
      //   })
      //   setLocation(result.data.location)
      //   window.open(result.data.location,"_self");
      // }else{
      //   window.open(location,"_self");
      // }
      const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var byteCharacters = atob(Base64Pdf)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], { type: "application/pdf" })
        window.navigator.msSaveOrOpenBlob(blob, fileName)
        return
      }
      // For Other Browsers
      const linkSource = "data:application/pdf;base64," + Base64Pdf
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()
  
      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
    }
  
    const handleOnChange = () => {
      setIsChecked(!isChecked);
    };
  
    const downloadPdf = async () => {
      let sendEmailPdfData = pdfData
      if (!sendEmailPdfData) {
        if (!biApiData) {
          return
        } else {
          let pdfResult = await pdfDownload({
            applicationNumber: journeyState.applicationNo,
            TID: biApiData?.TransactionId || "",
          })
          setPdfData(pdfResult.data.Base64Pdf)
          sendEmailPdfData = pdfResult.data.Base64Pdf
        }
      }
      downloadLinkOfPdf(sendEmailPdfData)
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "download", journeyState)
    }
  
    const printPdf = async () => {
      if (pdfData) {
        printPdf1(pdfData)
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        printPdf1(pdfResult?.data?.Base64Pdf)
      }
  
      function printPdf1(base64Data) {
        const newWindow = window.open("", "", "width=100, height=100")
        if (newWindow) {
          const document = newWindow.document.open()
          document.close()
          newWindow.moveTo(0, 0)
          newWindow.resizeTo(window.screen.width, window.screen.height)
          const contentType = "application/pdf"
          const b64Data = base64Data
          const blob = b64toBlob(b64Data, contentType)
          const blobUrl = URL.createObjectURL(blob)
          document.write(`<iframe id="pdfDocument"
          src="${blobUrl}" 
          width="100%"
          height="100%"
          frameBorder="0" ></iframe>`)
          const docs = document.getElementById("pdfDocument")
          setTimeout(() => {
            docs.contentWindow.print()
          }, 1000)
        }
      }
      function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || ""
        sliceSize = sliceSize || 512
  
        var byteCharacters = atob(b64Data)
        var byteArrays = []
  
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize)
  
          var byteNumbers = new Array(slice.length)
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }
  
          var byteArray = new Uint8Array(byteNumbers)
  
          byteArrays.push(byteArray)
        }
  
        var blob = new Blob(byteArrays, { type: contentType })
        return blob
      }
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "print", journeyState)
    }
  
    const sendEmail = async (callS3uploadPdf) => {
      if (!biApiData) {
        return
      }
      let payload = {
        journeyId: journeyState.journeyId,
        module: "BIEMAIL",
        applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
        TID: biApiData?.TransactionId || "",
      }
      sendEmailBI(payload).then(res => {
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
        } else {
          errorToastr(res.message)
        }
      })
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "email", journeyState)
    }
  

    //async function to make API call
    const getData = async () => {
      console.log("journeyState",journeyState.journeyId);
      let applicationDetailsPayload = {
        _id: journeyState.journeyId,
      }
      let applicationResult = await fetchApplicationDetails(
        applicationDetailsPayload
      )
  
      let payload = {
        journeyId: journeyState.journeyId,
        allRowData: true,
      }
      let journeyResult = await fetchAllJourneyData(payload)
      console.log("journeyresult",journeyResult);
      if (journeyResult?.lifeAssuredDetails?.proceedWith) {
        setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
      }
      if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
        setPayNowOrLater("later")
      }
      generateBI(payload).then(async data => {
        console.log(journeyResult, data, "vjhdvhhs")
        setAllJourneyData(journeyResult)
        setJourneyState(prev => {
          return {
            ...prev,
            premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_TAX) || 0,
            journeyData: applicationResult.applicationData,
          }
        })
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: data.data.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        setBiApiData(data.data)

        getTOFpaymentReceipt(journeyState.applicationNo)
        .then(res => {
          const receipts = res.data || [];
          const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
          let sum = 0;
          validReceipts.forEach(receipt => {
            sum += parseInt(receipt.amount);
          });
          if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_TAX))) {
            setSkipPayment(true);
          }
          setJourneyState(prev => ({
            ...prev,
            receipts: validReceipts 
          }));
        })
        .catch(err => console.info(err));

      })
      .catch(err => {
        console.log("error in save application of save application and call BI function")
      })
    }
  
    const handleEnterPayoutOption = (event, value) => {
      console.log(event.key);
      if (event.key == 'Enter') {
        handlePayOption({ target: { value: value } })
      }
  
    }
  
    //Use Effects
    useEffect(async () => {
      console.log("getdata callaed");
      await getData();
      console.log("bidattttaaaa",biApiData);
    }, [])
  
    // useEffect(() => {
    //   storePdfData()
    // }, [biApiData])
  
    //Page Functions
    const handlePayOption = ({ target }) => {
      console.log(target.value, "value in BI");
      if (target.value === "now") {
        setPayNowOrLater("now")
      } else if (target.value === "later") {
        setPayNowOrLater("later")
      }
    }
  
    const handlePrevious = () => {
      let sectionIndex = props.currentSectionIndex
      let pageIndex = props.currentPageIndex
      let sectionIndexToEmpty = sectionIndex - 1
      let pageSectionIndexToEmpty =`${pageIndex}${sectionIndexToEmpty}`
      let eventCalledToFillObject = {}
      let eventCalledToFill = Object.keys(
        dataLayerEventState?.eventCalled
      ).filter(element => {
        return element !== pageSectionIndexToEmpty
      })
      console.log(eventCalledToFill);
      for(let i=0; i<eventCalledToFill.length;i++){
        eventCalledToFillObject[eventCalledToFill[i]] = true
      }
      console.log(eventCalledToFillObject);
      setDataLayerEventState(prev=>{
        return{
          eventCalled:{
            ...eventCalledToFillObject
          }
        }
      })
      console.log(dataLayerEventState);
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "previous", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
      if (proceedWithOption === "manually") {
        props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      }
    }
  
    // code of tab enter
    const handleEnterPrevious = (event) => {
      if (event?.key == 'Enter') {
        handlePrevious();
      }
    }
    // code of tab enter
    const handleEnterDownload = (event) => {
      if (event?.key == 'Enter') {
        downloadPdf();
      }
    }
    // code of tab enter
    const handleEnterPrint = (event) => {
      if (event?.key == 'Enter') {
        printPdf();
      }
    }
    // code of tab enter
    const handleEnterEmail = (event) => {
      if (event?.key == 'Enter') {
        sendEmail(true);
      }
    }
    // code of tab enter
    const handleEnterRecalculate = (event) => {
      if (event?.key == 'Enter') {
        handleReCalculate();
      }
    }
  
    const handleProceed = async ev => {
      ev.preventDefault()
      if (!isChecked) {
        return;
      }
      console.log("tessttttttxxxxxxxxxxx",props);

      // downloadLinkOfPdf(pdfData);
      sendEmail(true);
  
      if (payNowOrLater === "now") {
        let journeyFormatData = props.applicationDataInJourneyFormat()
        DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "payNow", journeyState)
        console.log("tesstttttt",journeyState.journeySteps.pages);
        let temp = journeyState.journeySteps
        if(["fillProposalForm", "PageFlexiEdgeFillProposalForm"].includes(temp.pages[2].pageId)){
          let element = temp.pages[3]
          temp.pages.splice(3, 1)
          temp.pages.splice(2, 0, element)
        }
        setJourneyState(prev => {
          return {
            ...prev,
            journeySteps: temp,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            paymentStep: "N",
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      console.log("journeystateeee",journeyState);

      }else{
        let journeyFormatData = props.applicationDataInJourneyFormat()
        DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "payLater", journeyState)
        console.log("tesstttttt",journeyState.journeySteps.pages);

        let temp = journeyState.journeySteps
        if(["makePayment"].includes(temp.pages[2].pageId)){
          let element = temp.pages[3]
          temp.pages.splice(3, 1)
          temp.pages.splice(2, 0, element)
        }
        setJourneyState(prev => {
          return {
            ...prev,
            journeySteps: temp,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            paymentStep: "L",
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      }
      console.log("journeystateee222222222222222e",journeyState);
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
      let sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          paymentStep: payNowOrLater === "now" ? "N" : "L",
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          planOption: journeyState.planOption,
          canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
          },
          posDashboardListingData:{
            canaraPosCaseType: "sendCaseToCustomer"
          }
        // base64Data: pdfData,
      }
      saveApplication(sendPayload).then(res => {
        console.log(res, "application response")
        props.setCurrentPageIndex(prev => prev + 1)
        setErrorState({})
        setErrorState({})
        setErrorState({})
        setErrorState({})
        props.setCurrentSectionIndex(0) 
        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
      }).catch(err => {
        console.log(err, "err in saveApplication benefit-illustration")
      })
    }
  
    const handleProceedSkipPayment = (e) => {
      e.preventDefault();
    
      const temp = journeyState.journeySteps;
      console.log(temp);
      let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
      let fillProposalFormPageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm");
      let makePaymentPageSections = temp.pages[makePaymentPageIndex].sections;
      makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
      temp.pages[makePaymentPageIndex].sections = makePaymentPageSections;
      let tempPage = temp.pages[makePaymentPageIndex];
      temp.pages[makePaymentPageIndex] = temp.pages[fillProposalFormPageIndex];
      temp.pages[fillProposalFormPageIndex] = tempPage;
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp
        }
      });
    
      let sendPayload = {
        applicationData: journeyState.journeyData,
        skipPayment:'Y',
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex + 1,
          lastSection: 0,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)|| 0,
          lastPageCode: props.pageId,
          paymentStep: "N",
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          planOption: journeyState.planOption,
          canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
        },
        // base64Data: pdfData,
      }
    
      saveApplication(sendPayload).then(async res => {
        console.log(res, "application response");
        props.setCurrentPageIndex(prev => prev + 1);
        setErrorState({});
        props.setCurrentSectionIndex(0); // this moves to first section of next page
    
        // Save transaction details if skipPayment is true
        if (skipPayment) {
          const validReceipts = journeyState.receipts || [];
          const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
    
          const transactionPayload = {
            journeyId: journeyState.journeyId,
            applicationNumber: journeyState.applicationNo,
            status: 'Success',
            skipPayment: 'Y',
            transactions: transactions
          };
    
          let saveResp = await saveTransactionDetails(transactionPayload);
          //console.log(saveResp, "saveTransactionDetails");
        }
        
  
      }).catch(err => {
        console.log(err, "err in saveApplication benefit-illustration");
      });
    }

    const handleReCalculate = () => {
      setDataLayerEventState(prev => {
        return({
          ...prev,
          eventCalled: {
          }
        })
      })
      let journeyFormatData = props.applicationDataInJourneyFormat()
      DataLayerIntegration(journeyFormatData, "", props.sections?.[props.currentSectionIndex]?.sectionId, "reCalculate", journeyState)
        props.setCurrentPageIndex(0)
        props.setCurrentSectionIndex(0)
        const tempPage = journeyState.journeyData[0]
        setPageState(prev => {
          return {
            ...prev,
            pageId: tempPage.pageId,
            pageData: tempPage.pageData,
          }
        })
        const tempState = journeyState.journeyData[0].pageData[0]
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: tempState.sectionId,
            sectionData: tempState.sectionData,
          }
        })
    }

    const handleSendLinkToSales = (ev) => {
      ev.preventDefault()
      if (!isChecked) {
        return;
      }
      sendEmail(true);
      console.log("tesstttttt",journeyState.journeySteps.pages);
      let temp = journeyState.journeySteps

      temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
      temp.pages.push(...lookup.sendLinktosales)
      if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
        temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
      }
      console.log(temp.pages)

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
          canaraPosCaseType: "sendLinktosales"
        }
      })
    console.log("journeystateeee",journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    //let optInPayload = {
    //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
    // }
    // let whatsAppOptres = whatsAppOptin(optInPayload)
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        planOption: journeyState.planOption,
        canaraPosCaseType: "sendLinktosales"
      },
      posDashboardListingData:{
        canaraPosCaseType: "sendLinktosales"
      }
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      successToastr('Application will be visible on sales Dashboard after SCR Declaration')
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
    }


    let personalDetails = [
        {
            q1: "Date of Birth",
            ans1: allJourneyData?.lifeAssuredDetails?.dob ?  maskInFormat(allJourneyData?.lifeAssuredDetails?.dob * 1000) : "NA" ,
            
        },
        {
            q1: "Age",
            ans1: getAge(allJourneyData?.lifeAssuredDetails?.dob) || "NA",
            
        },
        {
            q1: "Designation",
            ans1: getValueFromLookup("natureOfOccupation", allJourneyData?.lifeAssuredDetails?.employmentDetails?.natureOfOccupation) || "NA"
            
        },
        {
            q1: "Gender",
            ans1:getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender) || "NA"
           
        },
        {
            q1: "Date of Illustration	",
            ans1: allJourneyData?.basicDetails?.applicationNoGenerationTime ? moment.unix(allJourneyData?.basicDetails?.applicationNoGenerationTime).utcOffset("+05:30").format("DD/MMM/YYYY") : "NA" ,
            
        },
        {
            q1:"Sum Assured(₹)",
            ans1:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].SUM_ASSURED_MATURITY)) : "NA"}`
        },
        {
            q1:"Illustration for Standard Life",
            ans1:"Illustration for Standard Life"
        },
        {
           q1:"Employer/Organisation ",
           ans1: (getValueFromLookup(
            "companyList", allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerName
          )) || "NA"
        }
    ]
    let planDetails = [
        {
            q1: "Proposal Number",
            ans1: allJourneyData?.basicDetails.applicationNumber,
            
        },
        {
            q1: "Name of the Plan",
            ans1: "Canara HSBC Life Insurance Guaranteed Savings Plan",
            
        },
        {
            q1: "Plan Option",
            ans1: getValueFromLookup("planOption",allJourneyData?.productDetails?.planOption)
            
        },
        {
            q1: "Policy Term",
            ans1: allJourneyData?.productDetails?.policyTerm || "NA"
           
        },
        {
            q1: "Premium Payment Term",
            ans1: allJourneyData?.productDetails?.premiumPaymentTerm || "NA"
            
        },
        {
            q1:"Premium Payment Frequency",
            ans1:`${lineCapital(getValueFromLookup(
              "premiumFrequency",
              allJourneyData?.productDetails?.premiumFrequency
            ) ?? '') || "NA"}`,
        },
        {
            q1:"Annualised Premium",
            ans1:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].ANNUALIZED_PREMIUM)) : "NA"}`
        },
        {
            q1:"Installment Premium Year 1 (without Goods and Services Tax & Cess (es)/ levy, if any)",
            ans1:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM)) : "NA"}`
        },
        {
            q1:"Installment Premium Year 2 onwards (without Goods and Services Tax & Cess (es)/ levy, if any):",
            ans1:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM)) : "NA"}`
        },
        {
            q1:"Installment Premium for Year 1 (with Goods and Services Tax & Cess (es)/ levy, if any):",
            ans1:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`
        },
        {
            q1:"Installment Premium from Year 2 onwards (with Goods and Services Tax & Cess (es) levy, if any):",
            ans1:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[1].MODAL_PREM_TAX)) : "NA"}`
        }
    ]


    
  return (
    <>
        <style>
        {`

        .option-buit-design-new-new-design::after{
        height: 2rem
        }
        .shadow-box-card{
        background-color: #fff;
        box-shadow: 0px 0px 10px #ccc;
        border-radius: 10px;
        padding: 0px 0px;
        float: left;
        width: 100%;
        margin-bottom: 30px;
        height: 172px;
        }
        .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
        background-color: #ededed;
        left: 0px;
        top: 0px;
        }
        radio-line{
        width: 100%;
        height: 100%
        }
        .customradio{
        padding: 22px 0px
        }
        .customradio .checkmark {
        top: 22px !important;
        }
        .by-pay{
        bottom: 8px
        }
        resent-bi-center{
        position: relative;
        }
        .eky-resend {
        margin: auto;
        right: 25px;
        position: relative;
        left: 4px
        }
        .custom-otp{
        margin: auto
        }
    
    `}

        </style>
      {allJourneyData && biApiData && (<div className='container'>
        <form id="declaration-form" name="declaration-form" action method="post" autoComplete="off" noValidate="novalidate">
          <div className="iselect-padding mt-20">
            <div className="iselect-box-design mb">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">Benefit Illustration</h1>
                  <span className="subhead">Canara HSBC Life Insurance Guaranteed Savings Plan &nbsp; |  &nbsp; UIN: 136N066V02 </span> </div>
                <div className="app-quatation mt hidden-desktop-screen">
                  <div className="application-design-number">Application Number: {journeyState.applicationNo}</div>
                </div>
              </div>
              <div className="bi-summary">
                <div className="auther-description mt-20">
                <h3>
                      Dear{" "}
                      {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                      {" "}
                </h3>
                  <p className="benefit-title">Thank you for showing interest in our Canara HSBC Life Insurance Guaranteed Savings Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended.
                  <br/>
                  <br/>
                  Please note that this illustration is indicative and the actual values may vary depending on performance of the participating fund managed by the Company.
                  </p>
                </div>
              </div>
              <div className="Bi-design-structure-table mt-50 iselect-mg-bottom d-flex row">
                <div className="col-lg-6 col-md-12 pe-2">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Personal Details of Life to be Assured</h2>
                    <div className="table-bg">
                      <table className="table" style={{"margin":"1px"}}>
                        <tbody>
                            {personalDetails.map((elem, index)=>{
                              return(
                              <tr className={`table-color${index%2!==0?"-grey":""}`}>
                                  <td width="30%">{elem.q1}</td>
                                  <td width="70%" align="right" className="rd-tatav">{elem.ans1}</td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

              <div className="col-lg-6 col-md-12 p-3 pt-0 pe-2">
              <div className="table-responsive table-design">
                <h2 className="headline-table">Plan Details</h2>
                <div className="table-bg">
                  <table className="table" style={{"margin":"1px"}}>
                      <tbody>
                          {planDetails.map((elem, index)=>{
                              return(
                              <tr className={`table-color${index%2!==0?"-grey":""}`}>
                                  <td width="60%">{elem.q1}</td>
                                  <td width="40%" align="right" className="rd-tatav">{elem.ans1}</td>
                              </tr>)
                          })}
                      </tbody>
                  </table>
                </div>
              </div>
            </div>
              </div>
              <div className="clearfix" />

              <div className="Bi-design-structure-table iselect-mg-bottom d-flex">
                <div className="col-lg-12 col-md-12 col-xs-12 col-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Guaranteed Maturity Benefit - {`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[allJourneyData?.productDetails?.policyTerm -1].MATURITY_BENEFIT)) : "NA"}`}</h2>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="transactionDetailsWrap">
                <div className="detailContentWrap">
                    <div className="row">
                    <div className="buttonWrap">
                        <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                        >
                            <a> Download</a></div>
                        <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                        >
                        <a> Print</a></div>
                        <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {sendEmail(true)}}
                        >
                        <a> Email</a></div>
                        <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{
                          cursor:
                            proceedWithOption === "manually"
                              ? "pointer"
                              : "default",
                        }}
                        tabIndex="0"
                        disabled={
                          proceedWithOption === "manually" ? false : true
                        }
                        onKeyPress={(e) => handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                        
                        >
                        <a>Re-Calculate</a></div>
                    </div>
                    </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div className="col-md-12">
                  <div className="option-buit-design-new-structure-box">
                  {allJourneyData?.journeyType !== "CanaraPos" && !skipPayment && (
                          <div className="option-buit-design-new-structure-selected">
                            <div className="row">
                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="now"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "now" ? true : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_TAX
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Now!
                                          </span>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Pay your{" "}
                                            {lineCapital(
                                              getValueFromLookup(
                                                "biFrequencyLabel",
                                                allJourneyData?.productDetails
                                                  ?.premiumFrequency
                                              ) ?? ""
                                            ) || "NA"}{" "}
                                            Premium{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_TAX
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            now and proceed.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>

                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="later"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "later"
                                            ? true
                                            : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_TAX
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Later!
                                          </span>
                                          <div></div>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Continue with your application and
                                            pay
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_TAX
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            later.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>
                            </div>
                          </div>
                      )}
                      {skipPayment && <p style={{
                        textAlign : "center",
                        fontSize : "18px",
                        marginTop : "30px"

                        }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`} is adjusted against transfer of funds from old application</p>}
                  </div>
                </div>
              </div>
              <div className="clearfix" />
               <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div className="col-md-12">
                  <div className="but-center text-center">
                  {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    }
                    <input onClick={skipPayment? handleProceedSkipPayment : handleProceed} className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="button" value="PROCEED"  />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
              
                  </div>
                </div>
              </div>

            </div>
          </div>
        </form>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design">
              <h2>Important Notes: </h2>
              <ul>
               <li>Guaranteed Maturity Benefit = Guaranteed Sum Assured on Maturity + Cumulative Guaranteed Yearly Additions + Guaranteed Loyalty Addition </li>
               <li>
                  <ol type="a">
                        <li>Guaranteed Savings Option: The Death Benefit is the benefit payable on death of the Life Assured, which is Sum Assured on Death plus Guaranteed Yearly Additions accrued till the date of death. Where Sum Assured on Death is defined as Higher of (11 times the Annualized Premium or Guaranteed Sum Assured on Maturity or Absolute amount assured to be paid on death or 105% of the Total Premiums Paid till the date of death), </li>
                        <li>Guaranteed Savings with Double Protection Option: The Death Benefit is the benefit payable on death of the Life Assured, which is Sum Assured on Death plus Guaranteed Yearly Additions accrued till the date of death. If death of the Life Assured is due to an accident, an additional amount equal to the ADB Sum Assured will be paid to the Nominee. Where Sum Assured on Death is defined as Higher of (11 times the Annualized Premium or Guaranteed Sum Assured on Maturity or Absolute amount assured to be paid on death or 105% of the Total Premiums Paid till the date of death), </li>
                        <li> Guaranteed Savings with Premium Protection Option: The Death Benefit is the benefit payable on death of the Life Assured, which is Sum Assured ion Death. In addition, future premiums are not payable and on maturity, Guaranteed Sum Assured on Maturity plus Accrued Guaranteed Yearly Additions and Guaranteed Loyalty Addition, will be payable. Where Sum Assured on Death is defined as Higher of (11 times the Annualized Premium or Guaranteed Sum Assured on Maturity or Absolute amount assured to be paid on death or 105% of the Total Premiums Paid till the date of death) </li>

                  </ol>
               </li>

               <li> Minimum Guaranteed Surrender Value / Special Surrender Value is payable at the end of the policy year.</li>
               <li>Annualized premium mentioned excludes rider premiums, underwriting extra premium and loadings for modal premiums, if any, as well as excludes Goods and Services Tax & applicable cess (es)/other levy, if any. </li>
               <li>Instalment premium mentioned above is inclusive of underwriting extra premium & loadings for modal premium, if any. </li>
               <li>A Policy shall acquire lapse status if the Policyholder fails to pay due premium within the Grace Period in the first 2 consecutive Policy years. In such case your Policy will lapse at the expiry of the grace period and the insurance cover will cease immediately. No benefit shall be payable upon death or upon your request for termination of the Policy or on the expiry of the revival period.</li>
               <li>Guaranteed Yearly Additions will be calculated as a percentage of cumulative Annualized Premium(s) paid and vary by the Premium Payment Term. Guaranteed Yearly Additions will accrue at the end of each Policy Year throughout the Premium Payment Term, provided all premiums due till the end of that Policy Year have been paid. </li>

            </ul>
            </div>
          </div>
        </div>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design" style={{marginTop:"0px",paddingTop:"0px"}}>
              <h2>Other points to note: </h2>
              <ul>
                <li>Guaranteed Yearly Addition (s) and Guaranteed Loyalty Addition will be payable provided all due premiums are paid and Policy is in-force.</li>
                <li>This is a traditional plan intended for long term savings and benefits. It is strongly advised that the Policy should be continued
                 throughout the defined Policy term to realize the full benefits. Early exit should not be opted for unless there is no other alternative 
                 available, as it will impact the Policy value. If premiums are discontinued after payment of at least first consecutive Policy 
                 yearsÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ premiums then the Policy will acquire a Paid-up value. You will receive this Paid-up value on death or on maturity,
                  provided you have not surrendered or revived the Policy. </li>
                <li>Your policy will acquire a guaranteed surrender value (GSV) after payment of at least first 2 consecutive policy years
                ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ premiums. However, the Company may offer a special surrender value (SSV), and higher of 
                GSV or SSV will be paid on surrender. The Illustration shows both the GSV as well as the current SSV payable on 
                surrender of the policy. SSV scales may be revised in the future by the Company with the prior approval of the Authority. </li>
                <li>You may be entitled for tax benefits under Section 80C and Section 10(10D), as per the Income Tax Act, 1961 as amended from time to time. </li>
                <li>The premium shown is for a healthy individual. Your application will be assessed as per Board approved underwriting Policy of the Company. 
                Basis underwriting, it may result in extra premium to be paid, which shall be borne by you. </li>
                <li>For more details on product features and terms and conditions please read sales brochure or sample Policy contract carefully before concluding a sale. </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design" style={{marginTop:"0px",paddingTop:"0px"}}>
              <h2>Disclosures:</h2>
              <p>Corporate Agent will receive commission basis the premium payment term (PPT) of the policy from the company for this transaction:-
              { allJourneyData?.productDetails?.premiumPaymentTerm === "10" ? "10 years PPT :- 30%" : allJourneyData?.productDetails?.premiumPaymentTerm === "7" ? "7 years PPT :- 21%":  allJourneyData?.productDetails?.premiumPaymentTerm === "5" ? "5 years PPT :- 15%": "" } commission on 1st year premium, 5% from 2nd year onwards. IRDA regulations do not permit Corporate Agent or its 
               employees to pay such commission, whether in part or whole, as an inducement to any person to take out or renew or continue an insurance policy of any kind. </p>
            </div>
          </div>
        </div>
        {/* <!--mobile view button--> */}
        <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
        <div className="iselect-mg-bottom">
            <div className="col-md-12">
            <div className="but-center text-center">
               {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ marginRight: "5px" }}
                        aria-hidden="true"
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ marginRight: "5px" }}
                          aria-hidden="true"
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                <div className="previous-btn cen">
                <a>
                    {" "}
                    <button
                    value="button1"
                    style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#fff",
                    }}
                    onClick={skipPayment ? handleProceedSkipPayment : handleProceed}
                    >
                    Proceed
                    </button>{" "}
                </a>
                </div>
                {allJourneyData?.journeyType === "CanaraPos" &&
                  <div className="previous-btn cen send-link-to-cust">
                      <span>
                        <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                  </div>
                }
                {/* <div className="previous-btn cen send-link-to-cust">
                  {allJourneyData?.journeyType === "CanaraPos" &&
                    <span>
                      <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                    </span>
                  }
                </div> */}
            </div>
            </div>
        </div>
        </div>
        {/* <!--mobile view button-->  */}
        <div className="clearfix"></div>
        
      </div>)}
    </>
  )
}
